module.exports = __webpack_public_path__ + "static/img/fa2.b6952aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/solution/fa2.png
// module id = zEF7
// module chunks = 3